<script>
import api from './../apiBridge'
import brandConfig from './../brandConfig'
import formatting from './../common/formatting.js'
import router from './../router';
import OrderHeader from './OrderHeader.vue';
import OrderItems from './OrderItems.vue';
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {getQueryStringParameterByName, 
        checkFilterCriteria,
        idFullStory
       } from './../common/utils.js'


const DEFAULT_POLLING_INTERVAL = 10 * 1000;
const SCREEN_FLIP_INTERVAL = 8 * 1000;
const TOTAL_ROWS_PER_COLUMN = 10;

export default {

  name: 'gfb',

  components: {
    'orderheader': OrderHeader,
    'orderitems': OrderItems,
    'swiper': swiper,
    'slide': swiperSlide
  },

  created: function () {
    // private data
  },


  methods: {

    checkLanguage() {
      if (!api.storeNumber) return;

      var self = this;
      var apiParameters = {};
      apiParameters.queryString = {};

      apiParameters.service = 'getIsEnglish';
      apiParameters.queryString['store_number'] = api.storeNumber;

      api.httpGet(apiParameters, function (response) {
        self.getOpenOrders();

        if (!response.data || response.data.error || response.status !=200 ) {
          // no language passed from Micros language injected from iOS if available
          api.setLanguage(window.config);
        } else {
          // set language
          api.language_flag = ''+response.status;

          console.log('Setting language from api: ' + response.data);

          if (response.data=='FR') {
            api.language = 'FR'
          } else {
            api.language = 'EN'
          }
        }

        self.$i18n.locale = api.language;
        self.$forceUpdate();

      });
    },
     
    getOpenOrders() {
      if (!api.storeNumber) return;
      if (this.pendingOrdersCall) return;
      console.log('Get open orders');

      var self = this;
      var apiParameters = {};
      apiParameters.queryString = {};

      apiParameters.service = 'getECommChecks';
      apiParameters.queryString['store_number'] = api.storeNumber;

      this.pendingOrdersCall = true;
      api.httpGet(apiParameters, function (response) {
        self.pendingOrdersCall = false;
        self.error = '';

        if (api.useOverride) {
          if (response.status !=200 ) { 
              self.error = self.$t('connection_error');
              return;            
          }
        } else if (!response.data || response.data.error || response.status !=200 ) {
          self.orderList = [];
          if (response.nativeError == 'no_data') {
            // continue - this just indicates there are no orders pending
          } else if (response.nativeError == 'connection_error') {
            self.error = 'ERR: ' + self.$t('connection_error');
            return;            
          } else if (response.errorMsg && response.errorMsg.response) {
            if (response.errorMsg.response.data && response.errorMsg.response.data.error == 'no_data') {
              // continue - this just indicates there are no orders pending
            } else {
              self.error = 'ERR: ' + self.$t('connection_error');
              return;
            }
          } else {
            self.error = 'ERR: ' + self.$t('no_internet');
            return;            
          }
        }

        self.processOrders(response.data);

      });
    },

    processOrders(orderListRaw) {
      this.timeCheckField = 'chk_open_date_time';
      let orderListNew = [];
      let orderItemsToUpdate = [];
      let inList = false;

      // choose only the latest from duplicate orders
      if (orderListRaw && orderListRaw.length) {
        for (let r=0; r < orderListRaw.length; r++) {
          // filter out any orders we shouldn't process
          if (this.filterOutOrder(orderListRaw[r])) {
            continue;
          }

          inList = false;
          for (let n=0; n < orderListNew.length; n++) {
            // replace any duplicate chk_nums with last record
            if (orderListRaw[r].checkdetails.chk_num == orderListNew[n].checkdetails.chk_num) {
              inList = true;
              if (orderListRaw[r].checkdetails.last_update_tm > orderListNew[n].checkdetails.last_update_tm) {
                orderListNew[n] = orderListRaw[r];
              }
            }
          }
          if (!inList && (!orderListRaw[r].checkdetails.autofire_time
                          || orderListRaw[r].checkdetails.autofire_time <= orderListRaw[r].checkdetails.Curr_DT)) {
            orderListNew.push(orderListRaw[r]);
          }
        }

        // set current time based on returned system time
        this.currentTime = (orderListRaw[0].checkdetails.Curr_DT)
                         ? formatting.dateFormat.dateFromStr(orderListRaw[0].checkdetails.Curr_DT)
                         : null;

      }

      // create a list of which orders need items updated based on last trans date comparison
      for (let n=0; n < orderListNew.length; n++) {
        if (this.orderList && this.orderList.length) {
          inList = false;
          for (let o=0; o < this.orderList.length; o++) {
            if (this.orderList[o].checkdetails.chk_num == orderListNew[n].checkdetails.chk_num) {
              inList = true;
              
              if (this.orderList[o].checkdetails.last_update_tm != orderListNew[n].checkdetails.last_update_tm) {
                orderItemsToUpdate.push(this.orderList[o].checkdetails.chk_num);
              } else if (this.orderList[o].hidden) {
                // persist hidden orders if not updated
                orderListNew[n].hidden = true;
              } else {
                if (this.orderList[o].refId) {
                  // persist refId if not updated
                  orderListNew[n].refId = this.orderList[o].refId;
                }
                // persist post pay flag if not updated
                orderListNew[n].postPay = this.orderList[o].postPay || false;

                if (this.orderList[o].source) {
                  // persist status if not updated
                  orderListNew[n].source = this.orderList[o].source;
                }

              } 
            }
          }
          if (!inList) {
            orderItemsToUpdate.push(orderListNew[n].checkdetails.chk_num);
          }
        } else {
          orderItemsToUpdate.push(orderListNew[n].checkdetails.chk_num);
        }

        this.setOrderDisplay(orderListNew[n]);
      }

      this.sortOrders(orderListNew);

      this.orderList = orderListNew;

      if (orderItemsToUpdate.length) {
        setTimeout(() => {
          for (let u=0; u < orderItemsToUpdate.length; u++) {
            if (this.$refs['orderItems'+ orderItemsToUpdate[u]]) {
              this.$refs['orderItems'+ orderItemsToUpdate[u]][0].getOrderItems();
            }
          }
        },100);
      }

      // calculate the pages between left and right display panel based on brand
      const orderPanelDisplay = api.appState.orderPanelDisplay;
      if (orderPanelDisplay) {
        this.calculatePagesCustom(orderPanelDisplay);
      } else {
        this.calculatePagesDefault();
      }
    },

    calculatePagesDefault() {
      // calc page segments of main order list to split among display panels
      // no distinction between left and right panels, just fill with orders

      let totalPages = Math.ceil(this.orderList.length / TOTAL_ROWS_PER_COLUMN);
      this.pagesLeft = [];
      this.pagesRight = [];

      for (let p=0; p<totalPages; p++) {
        // push one page to left panel and the rest of them to right panel
        if (this.pagesLeft.length) {
          this.pagesRight.push(this.orderList.slice(p*TOTAL_ROWS_PER_COLUMN, (p+1)*TOTAL_ROWS_PER_COLUMN));
        } else {
          this.pagesLeft.push(this.orderList.slice(p*TOTAL_ROWS_PER_COLUMN, (p+1)*TOTAL_ROWS_PER_COLUMN));
        }
      }

      // on right panel force scroll to 2nd page, first time it overflows
      // this is needed to "kick start" the autoplay on panelFlipper swiper
      if (totalPages > 2 && totalPages > this.totalPages) {
        setTimeout(() => {
          let panelFlipperRight = this.$refs.panelFlipperRight;
          panelFlipperRight.swiper.update();
          panelFlipperRight.swiper.slideTo(1);
        }, 200);
      }

      this.totalPages = totalPages;
    },

    calculatePagesCustom(orderPanelDisplay) {
      // calc page segments of main order list to split among display panels
      // Left Panel:  Mobile App Pick-up orders
      // Right Panel:  Aggregator Delivery orders

      this.pagesLeft = [];
      this.pagesRight = [];

      for (let o=0; o < this.orderList.length; o++) {
        // check left panel
        if (orderPanelDisplay.left.length) {
          for (let l=0; l < orderPanelDisplay.left.length; l++) {
            if (checkFilterCriteria(orderPanelDisplay.left[l].channel, this.orderList[o].checkdetails.last_name)
                && checkFilterCriteria(orderPanelDisplay.left[l].type, this.orderList[o].checkdetails.name)) {
              if (this.pagesLeft.length && this.pagesLeft[this.pagesLeft.length-1].length < TOTAL_ROWS_PER_COLUMN) {
                this.pagesLeft[this.pagesLeft.length-1].push(this.orderList[o]);
              } else {
                this.pagesLeft.push([]);
                this.pagesLeft[this.pagesLeft.length-1].push(this.orderList[o]);
              }
            }
          }
        } 

        // check right panel
        if (orderPanelDisplay.right.length) {
          for (let r=0; r < orderPanelDisplay.right.length; r++) {
            if (checkFilterCriteria(orderPanelDisplay.right[r].channel, this.orderList[o].checkdetails.last_name)
                && checkFilterCriteria(orderPanelDisplay.right[r].type, this.orderList[o].checkdetails.name)) {
              if (this.pagesRight.length && this.pagesRight[this.pagesRight.length-1].length < TOTAL_ROWS_PER_COLUMN) {
                this.pagesRight[this.pagesRight.length-1].push(this.orderList[o]);
              } else {
                this.pagesRight.push([]);
                this.pagesRight[this.pagesRight.length-1].push(this.orderList[o]);
              }
            }
          }
        }         
      }


      // on both panels force scroll to 2nd page, first time it overflows
      // this is needed to "kick start" the autoplay on panelFlipper swiper
      if (this.pagesLeft.length > 1 && this.pagesLeft.length > this.totalPagesLeft) {
        setTimeout(() => {
          let panelFlipperLeft = this.$refs.panelFlipperLeft;
          panelFlipperLeft.swiper.update();
          panelFlipperLeft.swiper.slideTo(1);
        }, 200);
      }
      this.totalPagesLeft = this.pagesLeft.length;

      if (this.pagesRight.length > 1 && this.pagesRight.length > this.totalPagesRight) {
        setTimeout(() => {
          let panelFlipperRight = this.$refs.panelFlipperRight;
          panelFlipperRight.swiper.update();
          panelFlipperRight.swiper.slideTo(1);
        }, 200);
      }
      this.totalPagesRight = this.pagesRight.length;


    },

    filterOutOrder(order) {
      // returns true if the order should be filtered out
      // for valid orders, returns false

      // ignore anything in the order channel exclusion list
      const excludeList = api.appState.orderChannelExclusionList;
      if (excludeList && excludeList.length) {
        for (let e = 0; e < excludeList.length; e++) {
          if (checkFilterCriteria(excludeList[e].channel, order.checkdetails.last_name)
              && checkFilterCriteria(excludeList[e].type, order.checkdetails.name)) {

            return true;
          }
        }
      }

      return false;
    },    

    sortOrders(orderList) {
      if (!orderList) {
        orderList = this.orderList;
      }

      // sort orders according to status: Ready at top
      // by datetime oldest to newest
      var self = this;

      const statusOrder = ['Visit Counter', 'Ready to Go!'];  // in reverse order so not-in-list==-1 comes last

      orderList.sort(function(a,b) {
        /*
          let aIndex = statusOrder.indexOf(a.status);
          let bIndex = statusOrder.indexOf(b.status);

          if (aIndex > bIndex) return -1;
          if (aIndex < bIndex) return 1;
          return 0;
        */


          const dta = formatting.dateFormat.dateFromStr(a.checkdetails[self.timeCheckField]);
          const dtb = formatting.dateFormat.dateFromStr(b.checkdetails[self.timeCheckField]);

          if (dta > dtb)
              return 1;
          if (dta < dtb)
              return -1;
          return 0;

       });

    },

    setOrderDisplay(order) {
      let aggOrder = false;
      
      switch (order.checkdetails.obj_num) {
        case 2002:
        case 9999:
          // App or web online orders
          order.source = 'Online Order';
          if (order.postPay && !order.checkdetails.chk_clsd_date_time) {
            // check for post-pay and set status
            order.status = 'cashier';
            //order.color = '#F11823';
          } 
          break;
        case 106:
        case 105:
        case 111:
          // At counter in store orders
          // Customer name will be checked and updated later in item 'ref' field
          order.source = 'Take Out'
          break;
        case 3000:
        case 3001:
        case 3002:
        case 3003:
        case 3004:
          // Aggregator orders
          order.source = brandConfig.aggregatorNameRemap(order.checkdetails.last_name);
          aggOrder = true;
          break;
        default:
          order.source = order.checkdetails.last_name;
      }


      if (!order.status) {
        if (order.checkdetails.readyTime) {
          // check for ready
          order.status = 'ready';
          setTimeout(() => {
            this.setReadyDisplay(order);
          },200);
        } else {
          order.status = 'prep';
        }
      }
      
      if (order.status == 'ready') {
        order.color = '#01B51A';
      } else {
        order.color = 'black';
      }

      // build display name
      if (order.checkdetails.id && !aggOrder) {
        if (order.checkdetails.id.indexOf('-') >= 0) {
          order.displayName = '';
          let aName = order.checkdetails.id.split('-');

          for (let n=0; n<aName.length; n++) {
            // test for letters by removing all numbers
            let sTest = aName[n].replace(/\d+/g, '');            
            if (!sTest) {
              // pad any numbers to 3 digits
              order.displayName += ' - ' + formatting.numberFormat.pad(aName[n], 3);
            } else {
              order.displayName = (order.displayName) 
                                ? order.displayName + '-' + aName[n]
                                : formatting.stringFormat.capitalize(aName[n]);
            }
          }
        } else {
          order.checkdetails.id = order.checkdetails.id.replace(/\*/g, '');
          if (order.checkdetails.id) {
            order.displayName = formatting.stringFormat.capitalize(order.checkdetails.id) + ' - ' + order.checkdetails.chk_num;
          } else {
            order.displayName = order.source + ' - ' + order.checkdetails.chk_num;  
          }
        }
      } else {
        if (order.refId) {
          if (order.source == 'Take Out') {
            // in this case refId is customer name
            order.displayName = formatting.stringFormat.capitalize(order.refId) + ' - ' + order.checkdetails.chk_num; 
          } else {
            order.displayName = order.source + ' - ' + formatting.stringFormat.capitalize(order.refId);
          }
        } else if (order.checkdetails.id) {
          order.displayName = order.source + ' - ' + formatting.stringFormat.capitalize(order.checkdetails.id);
        } else {
          order.displayName = order.source + ' - ' + order.checkdetails.chk_num;
        }
      }

    },

    refreshOrders() {
      // visually refresh orders and items
      for (var o=0; o < this.orderList.length; o++) {
        if (this.orderItemsHash[''+this.orderList[o].checkdetails.chk_num]
            && this.$refs['orderItems'+ this.orderList[o].checkdetails.chk_num]
            && this.$refs['orderItems'+ this.orderList[o].checkdetails.chk_num][0]) {
//          this.$refs['orderItems'+ this.orderList[o].checkdetails.chk_num][0].overrideOrderItems(this.orderItemsHash[''+this.orderList[o].checkdetails.chk_num]);
        }

        if (this.orderList[o].ready) {
          this.setReady(this.$refs['order' + this.orderList[o].checkdetails.chk_num][0]);
        }

      }
    },



    setReadyDisplay(order) {
      if (!order || !order.checkdetails) return;
      this.setBorder(this.$refs['order' + order.checkdetails.chk_num][0], true, false);
    },

    setSeeCashierDisplay(order) {
      if (!order || !order.checkdetails) return;
      this.setBorder(this.$refs['order' + order.checkdetails.chk_num][0], true, true);
    },

    deselectOrder(order) {
      if (!order || !order.checkdetails) return;

      this.setBorder(this.$refs['order' + order.checkdetails.chk_num][0], false);
      this.selectedOrder = null;
    },

    hideOrder(orderInfo) {
      for (var o=0; o < this.orderList.length; o++) {
        if (this.orderList[o].checkdetails.chk_num == orderInfo.orderId) {
          this.orderList[o].hidden = true;
        }
      }
      this.$forceUpdate();
    },

    updateOrder(orderInfo) {
      // make a copy of the orderItems
      for (var o=0; o < this.orderList.length; o++) {
        if (this.orderList[o].checkdetails.chk_num == orderInfo.orderId) {
          //this.orderList[o].checkdetails.orderTicket = orderInfo.orderTicket;
          this.orderItemsHash[''+orderInfo.orderId] = {
            items: orderInfo.processedItems,
            orderTicket: orderInfo.orderTicket,
            refId: orderInfo.refId,
            postPay: orderInfo.postPay
          };

          this.orderList[o].refId = orderInfo.refId || '';
          this.orderList[o].postPay = orderInfo.postPay || false;

          // hide orders that have been voided
          if (orderInfo.voided) {
            this.orderList[o].hidden = true;
          } else {
            this.setOrderDisplay(this.orderList[o]);  
          }

//          this.sortOrders();
          this.$forceUpdate();

          break;
        }
      }

    },


    setBorder(panel, selected, ready) {
      if (!panel) return;
      const selStyle = (ready)
                     ? 'selected2'
                     : 'selected';
      if (selected) {
         panel.classList.add(selStyle);
      } else {
         panel.classList.remove(selStyle);
        }
    },

    setDataPolling(flag, duration) {
      // set Order data refresh interval on/off based on flag passed
      if (flag) {
        console.log('Setting polling interval to: ' + duration);
        this.pollingInterval = setInterval(() => {
          this.getOpenOrders();
        }, duration || DEFAULT_POLLING_INTERVAL);
      } else {
        console.log('Stopped polling.');
        if (this.pollingInterval) clearInterval(this.pollingInterval);
      }
    },

    gotoInfo() {
      router.push('/info');
    },

    reload() {
      location.reload(true);
    },

    calculateRowsForHeight() {
      const rowHeight = 70;
      const screenHeight = window.innerHeight * 0.87;

      this.totalRows = parseInt (screenHeight / rowHeight);
    },


    startElapsedTime() {
      if (this.elapsedTimeInterval) clearInterval(this.elapsedTimeInterval);
      this.elapsedTimeInterval = setInterval(() => {
        this.updateElapsedTime();
      }, 10000);
    },

    updateElapsedTime() {
      if (this.currentTime) {
        // add 1 second to current time counter
        this.currentTime.setSeconds(this.currentTime.getSeconds() + 10);

        if (this.orderList && this.orderList.length) {
          let autoBumpCount = 0;
          for (var o=0; o < this.orderList.length; o++) {
            
            const sOrderTime = this.orderList[o].checkdetails.readyTime;
            const dtOrderTime = formatting.dateFormat.dateFromStr(sOrderTime);
            const oElapsedTime = formatting.dateFormat.calcElapsedTime(dtOrderTime, this.currentTime);

            // check for auto-bump or expired orders
            if (this.checkAutoBump(this.orderList[o], oElapsedTime.totalMinutes)) {
              console.log('Auto-Bump: ' + this.orderList[o].checkdetails.chk_num + ' - ' + oElapsedTime.totalMinutes);

              const orderToBump = this.orderList[o];
              // stagger bump calls
              setTimeout(() => {
                this.bumpOrder(orderToBump);
                autoBumpCount++;
              }, autoBumpCount * 500);

              this.orderList.splice(o,1);
              continue;
            }
          }
        }
      }
    },

    checkAutoBump(order, minutes) {
      if (order.status == 'ready'
          && !order.hidden && minutes >= api.appState.autoBumpMinutes) {
        return true;
      } else {
        return false;
      }
    },

    bumpOrder(order, resultCallback) {
      var self = this;
      let orderId = order.checkdetails.chk_num;

      // perform bump api call
      console.log('Bump order: ' + orderId);
      var apiParameters = {};
      apiParameters.queryString = {};

      apiParameters.service = 'getBumpCheck'
      apiParameters.queryString['store_number'] = api.storeNumber;
      apiParameters.queryString['check_num'] = orderId;

      api.httpGet(apiParameters, function (response) {
        if (!response || response.data != 99) {
          console.log('Bump api call failed for order: ' + orderId);
          return;
        }


      });
    },    




    init(pollingInterval) {

      this.storeNumber = api.storeNumber;

//      this.calculateRowsForHeight();



      let language = '' + getQueryStringParameterByName('language');
      if (language) {
        api.language_flag = 'querystring';
        if (language.toLocaleUpperCase() == 'FR') {
          api.language = 'FR'
        } else {
          api.language = 'EN'
        }
        this.$i18n.locale = api.language;
        this.$forceUpdate();
      }

      if (api.language_flag===null) {
        this.checkLanguage();
      } else {
        this.getOpenOrders();
      }

      if (api.brand) {
        this.logoPath = 'static/assets/brand_logo_' + api.brand + '.png';

        if (api.brand == 'harveys') {
          this.bannerStyle = 'background-color: #e87726;'
          this.bannerStyle = 'display: none;'

          this.headerLeft = this.$t('mobile_app_pickup');
          this.headerRight = this.$t('delivery_pickup');

          this.logoLeftPath = 'static/assets/harveys_pickup.png';
          this.logoRightPath = 'static/assets/harveys_delivery.png';

        } else {
          this.bannerStyle = 'background-color: #ED1C24;'
        }
      }

      setTimeout(() => {
        // do an initial refresh to put orders in proper spots
        this.getOpenOrders();
      }, 2000);
      
      this.orderItemsHash = {};
      this.setDataPolling(true, pollingInterval);

      this.startElapsedTime();

      // fullstory id
      idFullStory(this.storeNumber);

    }

  },

  mounted: function(){
    console.log('Guest Facing Board page');
    // check stored state
    api.getState();
    api.setStore(api.storeNumber);

    document.body.style.backgroundColor = "#FFFFFF";

    // check for store number url parameter
    if (this.$route.params.storeID) {
      let storeID = parseInt(this.$route.params.storeID);
      api.setStore(storeID);
    }    

    if (api.storeSelected && api.storeNumber) {
      this.init();
    } else {
      if (process.env.ENABLE_WEB_LOGIN) {
        router.push('/login');
      } else {
        // check for storeId to be set on window by iOS app injection
        this.initInterval = setInterval(() => {
          if (window.config && window.config.storeId) {

            clearInterval(this.initInterval);

            api.setStore(window.config.storeId);
            api.setLanguage(window.config);
            api.setProxy(window.config);

            let pollingInterval = DEFAULT_POLLING_INTERVAL;

            // get the polling interval from iOS in seconds and set if in not in proxy mode
            if (!api.useProxyApi && window.config.refreshRate) {
              // set polling interval in milliseconds
              pollingInterval = 1000 * parseInt(window.config.refreshRate);
            }

            this.init(pollingInterval);
          }
        }, 500);
      }
    }

  },

  beforeDestroy() {
    if (this.pollingInterval) clearInterval(this.pollingInterval);
    if (this.initInterval) clearInterval(this.initInterval);
  },

  data() {
    return {
        orderList: [],
        pendingOrdersCall: false,
        selectedOrder: null,
        panelAnimation: [],
        panelShrink: [],
        panelFade: [],
        elapsedTime: [],
        currentTime: null,
        storeNumber: api.storeNumber,
        totalRows: TOTAL_ROWS_PER_COLUMN,
        totalPages: 0,
        pagesLeft: [],
        pagesRight: [],
        totalPagesLeft: 0,
        totalPagesRight: 0,
        headerLeft: '',
        headerRight: '',
        logoLeftPath: '',
        logoRightPath: '',
        logoPath: 'static/assets/brand_logo_swiss.png',
        bannerStyle: 'background-color: #ED1C24;',
        swiperOption: {
          slidesPerView: 'auto',
          direction: 'vertical',
          centeredSlides: false,
          preventClicks: false,
          preventClicksPropagation: false,
          spaceBetween: 5,
          allowTouchMove: true,
          slideToClickedSlide: true,
        },
        swiperOptionh: {
          spaceBetween: 0,
          autoplay: {
            delay: SCREEN_FLIP_INTERVAL,
            disableOnInteraction: false
          },
        },                  
        error: '...'
    }
  }

}

</script>

<template>
<div>
  <div style="position: absolute; color: white; right: 10px; top: 2px;">{{$t('store_number')}}: <b>{{storeNumber}}</b></div>
  <div class="row" :style="bannerStyle">
    <img class="gfb-logo" :src="logoPath" />
  </div>
  <div class="row" style="height:87%;position: fixed;width:100%;">
    <div class="col-sm-12">
      <br clear="all">

      <div class="panel-trans pull-left" 
       style="height: 100%; 
              width: 50%; 
              padding-right: 1%; 
              border-right: solid 2px;
              min-height: 88vh;"
      >
        <div v-if="headerLeft" 
         style="text-align: center;
                font-size:  4.5vh;
                font-weight: 800;
                border-bottom: solid 2px;
                border-color: black;
                margin: -15px 15px 15px 15px;
                padding-top: 0.8vh;
                padding-bottom: 0.1vh;
                background-color: #E87524;
                color: white;                
               "
        >
          <img v-if="logoLeftPath" style="margin: -1vh 3vh 1vh 0px; height: 8vh;" :src="logoLeftPath" />
          {{headerLeft}}
        </div>
        <swiper ref="panelFlipperLeft" :options="swiperOptionh">
          <slide v-for="page, pIndex in pagesLeft">
            <swiper :ref="'orderPanelLeft' + pIndex"
            :options="swiperOption"
            style="padding-left: 2%;"
            >      
              <slide v-for="order, index in pagesLeft[pIndex]" 
              v-if="!order.hidden" 
              :ref="'slide' + order.checkdetails.chk_num"
              > 
                  <div :ref="'order' + order.checkdetails.chk_num"
                    :class="{'panel': true,
                            'panel-default': true,
                            'box-shadow': true,
                            'in-prep': (order.status.indexOf('prep') >= 0),
                            'pulse-order': (order.status.indexOf('ready') >= 0),
                            'ready': (order.status.indexOf('ready') >= 0),
                            'cashier': (order.status.indexOf('cashier') >= 0),
                            'panel-trans': panelAnimation[index],
                            'panel-shrinking': panelShrink[index],
                            'panel-fade': panelFade[index]
                          }"
                    style="margin: 2px 0px; border: none;"
                  >

                    <div class="panel-heading">
                      <span class="display-name truncate">{{order.displayName}}</span>
                      <!--  <span style="float: left; width: 30%; text-align: center; font-size: 25px; font-weight: 800; margin: -6px 7% 0px -7%;" >{{order.checkdetails.chk_num}}</span> -->
                      <span class="order-status" :style="'color: ' + order.color + ';'">{{$t(order.status) || ''}}</span>
                    </div>
                  </div>
                    <div style="display: none;">
                      <orderitems :ref="'orderItems'+order.checkdetails.chk_num" 
                        :orderId="parseInt(order.checkdetails.chk_num)" 
                        :customerName="order.checkdetails.id"
                        :inGFB="true"
                        @updateOrder="updateOrder"
                        @hideOrder="hideOrder"
                      />
                    </div>
              </slide>
              
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </slide>
        </swiper>
      </div>

      <div class="panel-trans pull-right" style="height: 100%; width: 49%; padding-right: 1%;">
        <div v-if="headerRight"
         style="text-align: center;
                font-size: 4.5vh;
                font-weight: 800;
                border-bottom: solid 2px;
                border-color: black;
                margin: -15px 15px 15px 15px;
                padding-top: 0.8vh;
                padding-bottom: 0.1vh;
                background-color: #E87524;
                color: white;                
              "
        >
          <img v-if="logoRightPath" style="margin: 0vh 3vh 0vh 0px; height: 8vh;" :src="logoRightPath" />
          {{headerRight}}
        </div>
        <swiper ref="panelFlipperRight" :options="swiperOptionh">
          <slide v-for="page, pIndex in pagesRight">
            <swiper :ref="'orderPanelRight' + pIndex"
            :options="swiperOption"
            style="padding-left: 2%;"
            >      
              <slide v-for="order, index in pagesRight[pIndex]" 
              v-if="!order.hidden" 
              :ref="'slide' + order.checkdetails.chk_num"
              > 
                  <div :ref="'order' + order.checkdetails.chk_num"
                    :class="{'panel': true,
                            'panel-default': true,
                            'box-shadow': true,
                            'in-prep': (order.status.indexOf('prep') >= 0),
                            'pulse-order': (order.status.indexOf('ready') >= 0),
                            'ready': (order.status.indexOf('ready') >= 0),
                            'cashier': (order.status.indexOf('cashier') >= 0),
                            'panel-trans': panelAnimation[index],
                            'panel-shrinking': panelShrink[index],
                            'panel-fade': panelFade[index]
                          }"
                    style="margin: 2px 0px; border: none;"
                  >

                    <div class="panel-heading">
                      <span class="display-name truncate">{{order.displayName}}</span>
                      <!--  <span style="float: left; width: 30%; text-align: center; font-size: 25px; font-weight: 800; margin: -6px 7% 0px -7%;" >{{order.checkdetails.chk_num}}</span> -->
                      <span class="order-status" :style="'color: ' + order.color + ';'">{{$t(order.status) || ''}}</span>
                    </div>
                  </div>
                    <div style="display: none;">
                      <orderitems :ref="'orderItems'+order.checkdetails.chk_num" 
                        :orderId="parseInt(order.checkdetails.chk_num)" 
                        :customerName="order.checkdetails.id"
                        :inGFB="true"
                        @updateOrder="updateOrder"
                        @hideOrder="hideOrder"
                      />
                    </div>
              </slide>
              
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </slide>
        </swiper>
      </div>
    </div> 
  </div>
  
  <div class="row" style="position:fixed;bottom:5px;width:100%;z-index:20; ">
    <div class="col col-sm-2 pull-right">
        <button 
         @click="gotoInfo()"
         class="btn btn-lg pull-right btn-default"
         style="height: 24px; 
                width: 24px; 
                padding: 0px 3px 2px 3px; 
                font-weight: bold; 
                border-radius: 50%; 
                background-color: gold; 
                border: none; 
                color: #ED1C24;"
         :disabled="logoutTimeout"
        ><i class="fas fa-info-circle pull-left"
          style="margin: 2px 5px 0px 0px;"></i>
        </button>
    </div> 
  </div>
</div>
</template>

<style scoped>
/*
.in-prep {
  border:solid 3px #CCC;
}

.ready {
  border:solid 3px #01B51A;
}
.ready .panel-heading {
}

.cashier {
  border:solid 3px #F11823;
}
.cashier .panel-heading {
}
*/

.gfb-logo {
  height: 8vh;    
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.panel-heading {
  text-align: center;
  font-weight: bold;
  font-size: 4.1vh;
  height: 7.7vh;
  background-color: white;
  border: none;
  padding: 0.4vh 1vh;
}

.display-name {
  float: left; 
  width: 62%; 
  text-align: left;
}

.display-name:first-letter{
  text-transform: uppercase;
}

.order-status {
  float: right; 
  width: 37%; 
  text-align: left;
  padding-left: 2%;
}

.truncate {
  width: 28vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/*
.pulse-order {
   animation: pulse 1.8s linear infinite; 
}

@keyframes pulse {
    0% {
        transform: scale(1.0);
        opacity: 1.0;
    }
    50% {
        transform: scale(0.995);
        opacity: 0.8;
    }
    100%   {
        transform: scale(1.0);
        opacity: 1.0;
    }
}
*/

</style>


// WEBPACK FOOTER //
// GuestFacingBoard.vue?250c0f3f